// removed by extract-text-webpack-plugin
module.exports = {"component":"_2G5Fq0FtE6bHkuFOoMBXhv","label":"_1dSt3B-ePUflccMlBo1C49","img":"_2zog-3B6_pomah4D25QJFJ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyInputField/GoeasyCheckboxField/GoeasyCheckboxField.scss
 ** module id = 972
 ** module chunks = 0
 **/